import { render } from "./ConhecimentoView.vue?vue&type=template&id=e46f6f84&scoped=true"
import script from "./ConhecimentoView.vue?vue&type=script&lang=js"
export * from "./ConhecimentoView.vue?vue&type=script&lang=js"

import "./ConhecimentoView.vue?vue&type=style&index=0&id=e46f6f84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e46f6f84"]])

export default __exports__